import _extends from "@babel/runtime/helpers/extends";
import styles from './Content.st.css';
import React from 'react';
import Divider from '../../../Divider';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useBaseModalLayoutContext } from '../../BaseModalLayoutContext';
export var Content = function Content(_ref) {
  var dataHook = _ref.dataHook,
      className = _ref.className,
      children = _ref.children,
      contentHideDividers = _ref.contentHideDividers;

  var _useBaseModalLayoutCo = useBaseModalLayoutContext(),
      contentClassName = _useBaseModalLayoutCo.contentClassName,
      _useBaseModalLayoutCo2 = _useBaseModalLayoutCo.content,
      content = _useBaseModalLayoutCo2 === void 0 ? children : _useBaseModalLayoutCo2;

  className = classNames(contentClassName, className);
  return content && /*#__PURE__*/React.createElement("div", _extends({
    "data-hook": dataHook,
    "data-hidedividers": contentHideDividers
  }, styles('root', {
    hideTopDivider: contentHideDividers,
    hideBottomDivider: contentHideDividers
  }, {
    className: className
  })), !contentHideDividers && /*#__PURE__*/React.createElement(Divider, {
    className: styles.topDivider
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.innerContentWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.innerContent
  }, content)), !contentHideDividers && /*#__PURE__*/React.createElement(Divider, {
    className: styles.bottomDivider
  })) || null;
};
Content.displayName = 'BaseModalLayout.Content';
Content.propTypes = {
  /** additional css classes */
  className: PropTypes.string,

  /** data hook for testing */
  dataHook: PropTypes.string,

  /** the content you want to render in the modal, children passed directly will be treated as `content` as well */
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** hides the content scrolling dividers  */
  contentHideDividers: PropTypes.bool
};
Content.defaultProps = {
  contentHideDividers: true
};